<template lang="pug">
  v-card-text
    v-checkbox(v-model="answer" class="reading-mark" @change="emitAnswer" label="Прочитал(а)")

</template>

<script>
export default {
  name: 'TypeMark',
  data: () => ({
    answer: false,
  }),
  mounted() {
    this.emitAnswer();
  },
  methods: {
    emitAnswer() {
      this.$emit('answer', {
        fieldName: 'mark_reading',
        answer: this.answer,
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
